import {
  FC,
  useState,
  useContext,
  useEffect,
  createContext,
  Dispatch,
  SetStateAction,
} from "react";
import { Switch, FormGroup, FormControlLabel } from "@mui/material";
import GridEventProvider from "components/context/GridEventContext";
import { EMAILID_COOKIE, PORTFOLIO_TOTAL_REVENUE_DISPLAY } from "constant";
import { GridApi } from "ag-grid-community";
import { Cookies, getAccountUrlAndBody, transformAgGridRequest } from "utils";
import axios from "axios";
import { SmartSearchOverview } from "types/portfolio";
import { useLocalStorageState } from "ahooks/lib";

export const ToggleSummaryProvider = createContext<{
  totalLading: boolean;
  setTotalLading: Dispatch<SetStateAction<boolean>>;
}>({
  totalLading: false,
  setTotalLading: () => ({}),
});

const ToggleSummary: FC<{
  setCollectionColumns: any;
  setAOVCollectionColumns: any;
}> = ({ setCollectionColumns, setAOVCollectionColumns }) => {
  const { gridEvent } = useContext(GridEventProvider);
  const { setTotalLading } = useContext(ToggleSummaryProvider);
  const [isSummaryDisplay, setIsSummaryDisplay] = useLocalStorageState(
    PORTFOLIO_TOTAL_REVENUE_DISPLAY,
    {
      defaultValue: true,
    }
  );

  const [dataArr, setDataArr] = useState<SmartSearchOverview[]>([]);
  // let filterModel: { [key: string]: any } = {
  //   key: "init",
  // };

  useEffect(() => {
    if (gridEvent) {
      handleFilterModel(gridEvent.api.getFilterModel());
      gridEvent.api.addEventListener("filterChanged", (e: { api: GridApi }) => {
        const filterModel = e.api.getFilterModel();
        handleFilterModel(filterModel);
      });
    }
  }, [gridEvent]);

  const handleFilterModel = (filterModel: { [key: string]: any }) => {
    if (gridEvent && filterModel?.["key"] !== "init") {
      setTotalLading(true);
      const postData = transformAgGridRequest(
        {
          filterModel,
        },
        [],
        setCollectionColumns,
        setAOVCollectionColumns
      );

      const { body } = getAccountUrlAndBody({ emailid: Cookies.get(EMAILID_COOKIE) }, postData);
      axios
        .post<SmartSearchOverview[]>("/api/dataservice/v1/accounts/smart-search-overview", body)
        .then((res) => {
          const { data } = res;
          const summaryDisplay = localStorage.getItem(PORTFOLIO_TOTAL_REVENUE_DISPLAY);
          // add a object contains active data + inactive data to array
          const totalObj: any = {};
          data.length &&
            Object.keys(data[0])?.forEach((key) => {
              if (typeof data[0]?.[key as keyof SmartSearchOverview] === "number") {
                totalObj[key as keyof SmartSearchOverview] =
                  ((data[0]?.[key as keyof SmartSearchOverview] as number) || 0) +
                  ((data[1]?.[key as keyof SmartSearchOverview] as number) || 0);
              }
            });
          // object include total of active and inactive
          const arr = [...data, { ...totalObj }];
          setDataArr(arr);
          const includeInactive = filterModel?.externalSearch?.filter?.startsWith("true");
          gridEvent.api.setPinnedBottomRowData(
            summaryDisplay === "false"
              ? []
              : includeInactive && arr.length === 3
                ? arr
                : [arr[arr.length - 1]]
          );
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => setTotalLading(false));
    }
  };

  const toggleSummaryDisplay = (_e: any, checked: boolean) => {
    setIsSummaryDisplay(!isSummaryDisplay);
    const includeInactive =
      gridEvent?.api?.getFilterModel()?.externalSearch?.filter?.startsWith("true") || false;
    gridEvent?.api?.setPinnedBottomRowData(
      checked
        ? includeInactive && dataArr.length === 3
          ? dataArr
          : [dataArr[dataArr.length - 1]]
        : []
    );
  };

  return (
    <div style={{ marginLeft: 4 }}>
      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              size="small"
              checked={isSummaryDisplay}
              onChange={toggleSummaryDisplay}
              color="primary"
            />
          }
          label="Show Total ARR"
          labelPlacement="start"
          style={{
            marginLeft: -10,
            justifyContent: "space-between",
          }}
        />
      </FormGroup>
    </div>
  );
};

export default ToggleSummary;
